import revive_payload_client_4sVQNw7RlN from "/tmp/workspace/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/tmp/workspace/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/tmp/workspace/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/tmp/workspace/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/tmp/workspace/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/tmp/workspace/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/tmp/workspace/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/tmp/workspace/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/tmp/workspace/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KdjWP7ookf from "/tmp/workspace/dist-production/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/tmp/workspace/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import primevue_plugin_GTizyx7eCu from "/tmp/workspace/dist-production/primevue-plugin.mjs";
import plugin_client_533RIki58s from "/tmp/workspace/node_modules/@primevue/nuxt-module/dist/runtime/plugin.client.mjs";
import _01_sentry_client_2rh1pDAIty from "/tmp/workspace/plugins/01.sentry.client.ts";
import _02_rum_client_quN99Wr2dL from "/tmp/workspace/plugins/02.rum.client.ts";
import _03_scripts_client_bFXSLFFB59 from "/tmp/workspace/plugins/03.scripts.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KdjWP7ookf,
  prefetch_client_5tzzN0oIVL,
  primevue_plugin_GTizyx7eCu,
  plugin_client_533RIki58s,
  _01_sentry_client_2rh1pDAIty,
  _02_rum_client_quN99Wr2dL,
  _03_scripts_client_bFXSLFFB59
]